export enum LocalStorageKeys {
  COUNTRY_CODE = "countryCode",
  AVAILABLE_COUNTRY_CODES = "availableCountryCodes",
  SELLER_TOKEN = "sellerToken",
  ROLES = "roles",
  ACCESSES_PAGES = "accessesPages",
}
